export default {
  // meta
  Cash: "Espèces",
  Bank: "Banque",
  "Orange Money": "Orange Money",
  "Mobile Money": "Mobile Money",
  Crypto: "Crypto",
  Active: "Actif",
  Inactive: "Inactif",
  ID: "ID",
  Name: "Nom",
  Type: "Type",
  Status: "Statut",
  Currency: "Devise",
  "Created At": "Créé le",
  Actions: "Actions",

  // form
  "Account Number": "Numéro de compte",
  Description: "Description",

  // table
  "All types": "Tous les types",
  "All statuses": "Tous les statuts",
  "All shops": "Toutes les boutiques",

  // select
  "Finance Account": "Compte financier",
  "Search by name, type or currency": "Rechercher par nom, type ou devise",
  "Edit Selection": "Modifier la sélection",
  "No accounts found": "Aucun compte trouvé",

  // modals
  "Create Finance Account": "Créer un compte financier",
  "Edit Finance Account": "Modifier le compte",
  "Account Details": "Détails du compte",
  "Updated At": "Mis à jour le",

  // delete
  "Do you really want to delete this finance account?":
    "Voulez-vous vraiment supprimer ce compte financier ?",
  "Warning: This action is irreversible.":
    "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // block
  "Finance Accounts": "Comptes financiers",
  "Add Account": "Ajouter un compte",
  Submit: "Soumettre",

  cash: "espèces",
  bank: "banque",
  "MTN Mobile Money": "MTN Mobile Money",
  crypto: "crypto",
  active: "actif",
  inactive: "inactif",
  name: "nom",
  Balance: "Solde",
  balance: "solde",
  "Account number": "Numéro de compte",
  status: "statut",
  type: "type",
  actions: "actions",
  "Create Treasury Account": "Créer un compte de trésorerie",
  "Bank name": "Nom de la banque",
  "Openning Balance": "Solde d'ouverture",
  description: "description",
  cancel: "annuler",
  "Edit treasury account": "Modifier le compte de trésorerie",
  "Treasury accounts": "Comptes de trésorerie",
  "Add a treasury account": "Ajouter un compte de trésorerie",
};
